module.exports = __webpack_public_path__ + "static/ettin-1e94470572006aa4bd74101da0b8dd9b.jpeg";